// Kept separate from utils/payment so modules that only need the constants
// don't pull in that file's React icon components.

export const paymentResultsPath = '/api/fesc/v2/callback/payment'

export const paymentTypes = {
  offline: 0,
  paypal: 2,
  taishin: 4,
  chinatrust: 5,
  braintree: 6,
  stripe: 7,
  omise: 8,
  paypalExpressCheckout: 10,
  veritrans: 11,
  ipay88: 12,
  paydollar: 13,
  paylah: 14,
  wirecard: 15,
  boost: 16,
  linePay: 17,
  oddleVoucher: 19,
  stripeExpressAccount: 20,
}
